var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.user).length === 1
    ? _c("div", { staticClass: "row", attrs: { "data-id": _vm.user.id } }, [
        _c(
          "div",
          {
            staticClass: "avatar",
            class: {
              "icon-loading-small":
                _vm.loading.delete || _vm.loading.disable || _vm.loading.wipe
            }
          },
          [
            !_vm.loading.delete && !_vm.loading.disable && !_vm.loading.wipe
              ? _c("img", {
                  attrs: {
                    src: _vm.generateAvatar(_vm.user.id, 32),
                    srcset:
                      _vm.generateAvatar(_vm.user.id, 64) +
                      " 2x, " +
                      _vm.generateAvatar(_vm.user.id, 128) +
                      " 4x",
                    alt: "",
                    height: "32",
                    width: "32"
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [
          _vm._v("\n\t\t" + _vm._s(_vm.user.id) + "\n\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "obfuscated" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "settings",
                  "You do not have permissions to see the details of this user"
                )
              ) +
              "\n\t"
          )
        ])
      ])
    : !_vm.editing
    ? _c("UserRowSimple", {
        class: { "row--menu-opened": _vm.openedMenu },
        attrs: {
          editing: _vm.editing,
          "feedback-message": _vm.feedbackMessage,
          groups: _vm.groups,
          languages: _vm.languages,
          loading: _vm.loading,
          "opened-menu": _vm.openedMenu,
          settings: _vm.settings,
          "show-config": _vm.showConfig,
          "sub-admins-groups": _vm.subAdminsGroups,
          "user-actions": _vm.userActions,
          user: _vm.user
        },
        on: {
          "update:editing": function($event) {
            _vm.editing = $event
          },
          hideMenu: _vm.hideMenu,
          toggleMenu: _vm.toggleMenu
        }
      })
    : _c(
        "div",
        {
          staticClass: "row row--editable",
          class: {
            disabled: _vm.loading.delete || _vm.loading.disable,
            "row--menu-opened": _vm.openedMenu
          },
          attrs: { "data-id": _vm.user.id }
        },
        [
          _c(
            "div",
            {
              staticClass: "avatar",
              class: {
                "icon-loading-small":
                  _vm.loading.delete || _vm.loading.disable || _vm.loading.wipe
              }
            },
            [
              !_vm.loading.delete && !_vm.loading.disable && !_vm.loading.wipe
                ? _c("img", {
                    attrs: {
                      src: _vm.generateAvatar(_vm.user.id, 32),
                      srcset:
                        _vm.generateAvatar(_vm.user.id, 64) +
                        " 2x, " +
                        _vm.generateAvatar(_vm.user.id, 128) +
                        " 4x",
                      alt: "",
                      height: "32",
                      width: "32"
                    }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.user.backendCapabilities.setDisplayName
            ? _c("div", { staticClass: "displayName" }, [
                _c(
                  "form",
                  {
                    staticClass: "displayName",
                    class: { "icon-loading-small": _vm.loading.displayName },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.updateDisplayName($event)
                      }
                    }
                  },
                  [
                    _c("input", {
                      ref: "displayName",
                      attrs: {
                        id: "displayName" + _vm.user.id + _vm.rand,
                        disabled: _vm.loading.displayName || _vm.loading.all,
                        autocapitalize: "off",
                        autocomplete: "off",
                        autocorrect: "off",
                        spellcheck: "false",
                        type: "text"
                      },
                      domProps: { value: _vm.user.displayname }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "icon-confirm",
                      attrs: { type: "submit", value: "" }
                    })
                  ]
                )
              ])
            : _c("div", { staticClass: "name" }, [
                _vm._v("\n\t\t" + _vm._s(_vm.user.id) + "\n\t\t"),
                _c("div", { staticClass: "displayName subtitle" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            _vm.user.displayname.length > 20
                              ? _vm.user.displayname
                              : "",
                          expression:
                            "user.displayname.length > 20 ? user.displayname : ''"
                        }
                      ],
                      staticClass: "cellText"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.user.displayname) + "\n\t\t\t"
                      )
                    ]
                  )
                ])
              ]),
          _vm._v(" "),
          _vm.settings.canChangePassword &&
          _vm.user.backendCapabilities.setPassword
            ? _c(
                "form",
                {
                  staticClass: "password",
                  class: { "icon-loading-small": _vm.loading.password },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.updatePassword($event)
                    }
                  }
                },
                [
                  _c("input", {
                    ref: "password",
                    attrs: {
                      id: "password" + _vm.user.id + _vm.rand,
                      disabled: _vm.loading.password || _vm.loading.all,
                      minlength: _vm.minPasswordLength,
                      placeholder: _vm.t("settings", "Add new password"),
                      autocapitalize: "off",
                      autocomplete: "new-password",
                      autocorrect: "off",
                      required: "",
                      spellcheck: "false",
                      type: "password",
                      value: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "icon-confirm",
                    attrs: { type: "submit", value: "" }
                  })
                ]
              )
            : _c("div"),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "mailAddress",
              class: { "icon-loading-small": _vm.loading.mailAddress },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updateEmail($event)
                }
              }
            },
            [
              _c("input", {
                ref: "mailAddress",
                attrs: {
                  id: "mailAddress" + _vm.user.id + _vm.rand,
                  disabled: _vm.loading.mailAddress || _vm.loading.all,
                  placeholder: _vm.t("settings", "Add new email address"),
                  autocapitalize: "off",
                  autocomplete: "new-password",
                  autocorrect: "off",
                  spellcheck: "false",
                  type: "email"
                },
                domProps: { value: _vm.user.email }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "icon-confirm",
                attrs: { type: "submit", value: "" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "groups",
              class: { "icon-loading-small": _vm.loading.groups }
            },
            [
              _c(
                "Multiselect",
                {
                  staticClass: "multiselect-vue",
                  attrs: {
                    "close-on-select": false,
                    disabled: _vm.loading.groups || _vm.loading.all,
                    limit: 2,
                    multiple: true,
                    options: _vm.availableGroups,
                    placeholder: _vm.t("settings", "Add user in group"),
                    "tag-width": 60,
                    taggable: _vm.settings.isAdmin,
                    value: _vm.userGroups,
                    label: "name",
                    "tag-placeholder": "create",
                    "track-by": "id"
                  },
                  on: {
                    remove: _vm.removeUserGroup,
                    select: _vm.addUserGroup,
                    tag: _vm.createGroup
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noResult" }, slot: "noResult" },
                    [_vm._v(_vm._s(_vm.t("settings", "No results")))]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.subAdminsGroups.length > 0 && _vm.settings.isAdmin
            ? _c(
                "div",
                {
                  staticClass: "subadmins",
                  class: { "icon-loading-small": _vm.loading.subadmins }
                },
                [
                  _c(
                    "Multiselect",
                    {
                      staticClass: "multiselect-vue",
                      attrs: {
                        "close-on-select": false,
                        disabled: _vm.loading.subadmins || _vm.loading.all,
                        limit: 2,
                        multiple: true,
                        options: _vm.subAdminsGroups,
                        placeholder: _vm.t("settings", "Set user as admin for"),
                        "tag-width": 60,
                        value: _vm.userSubAdminsGroups,
                        label: "name",
                        "track-by": "id"
                      },
                      on: {
                        remove: _vm.removeUserSubAdmin,
                        select: _vm.addUserSubAdmin
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [_vm._v(_vm._s(_vm.t("settings", "No results")))]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.auto",
                  value: _vm.usedSpace,
                  expression: "usedSpace",
                  modifiers: { auto: true }
                }
              ],
              staticClass: "quota",
              class: { "icon-loading-small": _vm.loading.quota }
            },
            [
              _c("Multiselect", {
                staticClass: "multiselect-vue",
                attrs: {
                  "allow-empty": false,
                  disabled: _vm.loading.quota || _vm.loading.all,
                  options: _vm.quotaOptions,
                  placeholder: _vm.t("settings", "Select user quota"),
                  taggable: true,
                  value: _vm.userQuota,
                  label: "label",
                  "tag-placeholder": "create",
                  "track-by": "id"
                },
                on: { input: _vm.setUserQuota, tag: _vm.validateQuota }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showConfig.showLanguages
            ? _c(
                "div",
                {
                  staticClass: "languages",
                  class: { "icon-loading-small": _vm.loading.languages }
                },
                [
                  _c("Multiselect", {
                    staticClass: "multiselect-vue",
                    attrs: {
                      "allow-empty": false,
                      disabled: _vm.loading.languages || _vm.loading.all,
                      options: _vm.languages,
                      placeholder: _vm.t("settings", "No language set"),
                      value: _vm.userLanguage,
                      "group-label": "label",
                      "group-values": "languages",
                      label: "name",
                      "track-by": "code"
                    },
                    on: { input: _vm.setUserLanguage }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showStoragePath || _vm.showConfig.showUserBackend
            ? _c("div", { staticClass: "storageLocation" })
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showLastLogin ? _c("div") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "userActions" }, [
            !_vm.loading.all
              ? _c(
                  "div",
                  { staticClass: "toggleUserActions" },
                  [
                    _c(
                      "Actions",
                      [
                        _c(
                          "ActionButton",
                          {
                            attrs: { icon: "icon-checkmark" },
                            on: {
                              click: function($event) {
                                _vm.editing = false
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.t("settings", "Done")) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideMenu,
                            expression: "hideMenu"
                          }
                        ],
                        staticClass: "userPopoverMenuWrapper"
                      },
                      [
                        _c("div", {
                          staticClass: "icon-more",
                          on: { click: _vm.toggleMenu }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "popovermenu",
                            class: { open: _vm.openedMenu }
                          },
                          [
                            _c("PopoverMenu", {
                              attrs: { menu: _vm.userActions }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "feedback",
                style: { opacity: _vm.feedbackMessage !== "" ? 1 : 0 }
              },
              [
                _c("div", { staticClass: "icon-checkmark" }),
                _vm._v("\n\t\t\t" + _vm._s(_vm.feedbackMessage) + "\n\t\t")
              ]
            )
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }